import React from 'react';
import { BFIslandButton, BFIslandColors } from '@buzzfeed/react-components';
import { triggerEnhancedWebviewFeature } from '@buzzfeed/bf-utils/lib/webview';
import { AddFriendIcon } from '../../icons/Icons';
import { useTrackingContext } from '../../hooks';
import styles from './index.module.scss';

const InviteBanner = ({ variant = 'groupChat' }) => {
  const { trackContentAction } = useTrackingContext();

  const handleInviteClick = () => {
    trackContentAction({
      context_page_type: 'feed',
      context_page_id: variant === 'groupChat' ? 'groups' : 'create',
      unit_type: variant === 'groupChat' ? 'feed' : 'nav',
      unit_name: variant === 'groupChat' ? 'groups' : 'invite_banner',
      item_type: 'button',
      item_name: 'invite_a_friend',
      position_in_unit: 0,
      action_type: 'open',
      action_value: 'invite_a_friend',
    });

    // webview support check is handled in canUserInviteFriends util
    // which gates the rendering of this component
    triggerEnhancedWebviewFeature({
      feature: 'navigate',
      params: {
        path: '/invite',
      },
      version: 1,
    });
  };

  if (variant === 'creationLander') {
    return (
      <div className={styles.creationBanner}>
        <h2 className={styles.creationTitle}>Home</h2>
        <BFIslandButton
          text="Invite a friend"
          icon={<AddFriendIcon />}
          onClick={handleInviteClick}
          bgColor={BFIslandColors.LIME}
          size="small"
        />
      </div>
    );
  }

  return (
    <div className={styles.groupChatBanner}>
      <div className={styles.ctaContainer}>
        <span className={styles.tagline}>
          Island is
          <br />
          better together
        </span>
        <button
          type="button"
          className={`${styles.greenButton} ${styles.inviteButton}`}
          onClick={handleInviteClick}
        >
          Invite a friend
        </button>
      </div>
      <img
        src="https://www.buzzfeed.com/static-assets/isolated/bfpaigenerator-prod-public/images/chat/invite-characters.png"
        alt="Invite friends illustration"
        className={styles.illustration}
      />
    </div>
  );
};

export default InviteBanner;
